"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_es_1 = require("lodash-es");
/**
 * 1000 - 1 second
 * 60 - Conversion to 1 minute
 * 60 - Conversion to 1 hour
 * 24 - Conversion to 1 day
 * 14 - Conversion to 14 days
 */
const LOGO_CACHE_TTL = 1000 * 60 * 60 * 24 * 14;
const PML_CACHE_TTL = 1000 * 60 * 60;
//HUB_API_URL
const getHubApiUrl = () => {
    if (process.env.HUB_API_URL && process.env.HUB_API_URL != '') {
        return process.env.HUB_API_URL;
    }
    else {
        throw new Error('[HUB-API] Missing Environment Configuration. Take a look at environment variables');
    }
};
const getLogoByBrandName = (brands, sizeName, callback, onError) => {
    const availableLogos = [];
    const missingBrandLogos = [];
    lodash_es_1.default.forEach(lodash_es_1.default.uniq(brands), (brand) => {
        const brandLogoDetails = getLogoByBrandFromLocalStorage(brand, sizeName);
        if (brandLogoDetails) {
            availableLogos.push(brandLogoDetails);
        }
        else {
            missingBrandLogos.push(brand);
        }
    });
    if (!lodash_es_1.default.isEmpty(missingBrandLogos)) {
        fetchLogoByBrandFromAPI(missingBrandLogos, sizeName, (brandLogos) => {
            _persistBrandLogoToLocalStorage(brandLogos);
            availableLogos.push(...brandLogos);
            callback(availableLogos);
        }, onError);
    }
    else {
        callback(availableLogos);
    }
};
const getLogoByBrandNameAsync = (brands, sizeName, callback, onError) => {
    const availableLogos = [];
    const missingBrandLogos = [];
    lodash_es_1.default.forEach(lodash_es_1.default.uniq(brands), (brand) => {
        const brandLogoDetails = getLogoByBrandFromLocalStorage(brand, sizeName);
        if (brandLogoDetails) {
            availableLogos.push(brandLogoDetails);
        }
        else {
            missingBrandLogos.push(brand);
        }
    });
    if (!lodash_es_1.default.isEmpty(missingBrandLogos)) {
        populateMissingLogoByBrandName(missingBrandLogos, sizeName, () => {
            callback(availableLogos);
        }, onError);
    }
    else {
        callback(availableLogos);
    }
};
const getAvailableLogos = (sizeName, callback, onError) => {
    fetchLogoByBrandFromAPI([], sizeName, (brandLogos) => {
        _persistBrandLogoToLocalStorage(brandLogos);
        callback(brandLogos);
    }, onError);
};
const fetchLogoByBrandFromAPI = (brands, sizeName, callback, onError) => {
    try {
        fetch(`${getHubApiUrl()}/api/v1/logo?sizeName=${encodeURIComponent(sizeName)}&brands=${encodeURIComponent(brands.join(','))}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then(result => result.json())
            .then(data => callback(data))
            .catch(error => {
            console.error('Error while calling: fetchLogoByBrandFromAPI(...). Check console for details!');
            console.error(error);
            // TODO: This is just a workaround to avoid displaying the error on UI blocking all the report rendering.
            callback([]);
        });
    }
    catch (e) {
        console.log(`getLogoByBrandName Error: ${e}`);
        onError && onError(e);
    }
};
const populateMissingLogoByBrandName = (brands, sizeName, callback, onError) => {
    const requiredBrands = [];
    const currentTs = +new Date();
    lodash_es_1.default.forEach(lodash_es_1.default.uniq(brands), (brand) => {
        /**
         * PML: Means "Populate missing logo"
         */
        const pmlBrandKey = `PML-${brand}-${sizeName}`;
        const pmlBrandTs = +(localStorage.getItem(pmlBrandKey));
        if (pmlBrandTs == 0 || (pmlBrandTs > 0 && currentTs - pmlBrandTs > PML_CACHE_TTL)) {
            localStorage.setItem(pmlBrandKey, `${+new Date()}`);
            requiredBrands.push(brand);
        }
    });
    if (requiredBrands.length > 0) {
        try {
            fetch(`${getHubApiUrl()}/api/v1/logo`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    sizeName,
                    brands: requiredBrands
                }),
                credentials: 'include',
            })
                .then(result => result.text())
                .then(result => callback(JSON.parse(result || '{}')));
        }
        catch (e) {
            console.log(`populateLogoByBrandFromAPI Error: ${e}`);
            onError && onError(e);
        }
    }
};
const getLogoByBrandFromLocalStorage = (brand, sizeName) => {
    const itemKey = `${brand}__${sizeName}`;
    const itemValue = localStorage.getItem(itemKey);
    if (!itemValue) {
        return null;
    }
    const parsedItem = JSON.parse(itemValue);
    const { expiry, ...brandLogoDetails } = parsedItem;
    const now = new Date();
    if (now.getTime() > expiry) {
        localStorage.removeItem(itemKey);
        return null;
    }
    return brandLogoDetails;
};
const _persistBrandLogoToLocalStorage = (brandLogoDetailsList) => {
    const now = new Date();
    lodash_es_1.default.forEach(brandLogoDetailsList, (brandLogoDetails) => {
        const { brandName, logoSizeName } = brandLogoDetails;
        const key = `${brandName}__${logoSizeName}`;
        const item = {
            ...brandLogoDetails,
            expiry: now.getTime() + LOGO_CACHE_TTL,
        };
        localStorage.setItem(key, JSON.stringify(item));
    });
};
const Services = {
    getAvailableLogos,
    getLogoByBrandName,
    getLogoByBrandNameAsync,
    getLogoByBrandFromLocalStorage,
    populateMissingLogoByBrandName,
};
exports.default = Services;
